import React from 'react';
import { Box, CircularProgress } from '@mui/material';

export const Spinner = ({ className }: { className?: string }) => {
  return (
    <Box
      className={className}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress />
    </Box>
  );
};
